module.exports = {
  PAYMENT_STATUS: {
    DRAFTED: 'DRAFTED',
    QUEUED: 'QUEUED',
    PENDING: 'PENDING',
    AWAITING_FUNDS: 'AWAITING_FUNDS',
    ON_HOLD: 'ON_HOLD',
    READY_FOR_SETTLEMENT: 'READY_FOR_SETTLEMENT',
    PICKED_FOR_SETTLEMENT: 'PICKED_FOR_SETTLEMENT',
    SETTLED: 'SETTLED',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
    RETURNED: 'RETURNED',
    SCHEDULED: 'SCHEDULED'
  },
  PAYMENT_TYPE: {
    EXPRESS: 'EXPRESS',
    INSTANT: 'INSTANT',
    WIRE: 'WIRE'
  },
  PAYMENT_PREFERENCE: {
    REGULAR: 'REGULAR',
    PRIORITY: 'PRIORITY',
    EXPRESS: 'EXPRESS',
    INSTANT: 'INSTANT',
    WIRE: 'WIRE'
  },
  PAYMENT_STATUS_NOTE: {
    INSUFFICIENT_BALANCE: 'Insufficient Balance'
  },
  PAYMENT_SCHEDULED_TYPE: {
    INSTANT: 'INSTANT',
    SCHEDULED: 'SCHEDULED',
    RECURRING: 'RECURRING'
  }
};
